module.exports = __webpack_public_path__ + "img/app-haose.8fcec30e.webp";